import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=04741fee&scoped=true"
import script from "./videoList.vue?vue&type=script&lang=js"
export * from "./videoList.vue?vue&type=script&lang=js"
import style0 from "./videoList.vue?vue&type=style&index=0&id=04741fee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04741fee",
  null
  
)

export default component.exports